export class UserDc {
  public AuthenticationId: number = 0;
  public UserId: number = 0;
  public Affiliate1TypeId: number;
  public AffAffiliate1TypeId: number;
  // public Affiliate1IndustryId: number;
  public Affiliate1: number;
  public Affiliate1Name: string;
  public Affiliate2Name: string;
  public Affiliate3Name: string;
  // public ContactGoalId: number;
  public RoleId: number;
  public UserType: string;
  public UserName: string;
  public RoleName: string;
  public EmployeeId: number;
  public FirstName: string;
  public LastName: string;
  public FullName: string;
  public EmailId: string;
  public City: string;
  public ProfileImg: string;
  public UserThumbnail: string;
  public UserThumbnailUrl: string;
  public Result: boolean;
  public Message: string;
  public UserTypeId: number;
  public CustomerPortal: number;
  public ProgramId?;
  public ProgramIds?;
  public PortalLogoUrl?: string;
  public Token?: string;
  public JobTitle: string;
  public ContractDocumentId: number;
  public ContractSignatureStatus: string;
  public IsCCPayment: boolean;
  public Phone1: number;
  public AffiliateTypeId: number;
  public TeamLeadId: number;
  public TeamLeadName: string;
  public IsSSNAvailable: boolean;
  public IsSetUpCompleted: boolean;
  public IsCreditReportUploaded: boolean;
  public CreditMonitoringId: number;
  public LetterInPortal: string;
  public TeamContractId: number;
  public TeamPackage: number;
  public Affiliate1IndustryId: number;
  public Affiliate2TypeId: number;
  public Affiliate3TypeId: number;
  public AFF1Company: string;
  public AFF1TeamLead: string;
  public AFF1TeamLeadCompany: string;
  public AFF2Company: string;
  public AFF2TeamLead: string;
  public AFF2TeamLeadCompany: string;
  public AFF3Company: string;
  public AFF3TeamLead: string;
  public AFF3TeamLeadCompany: string;
  public CMStatus: string;
  public BotTeams: string;
  public BotStrategies: string;
  public TrackingLink: string;
  public SID: any;
  public AffiliatePortalDisplayId: any;
  public PackageId: number;
  public HasCustomerLeftCRM: boolean = false;
  public CreditMonitoringName: string;
  public CMDisplayName: string;
  public SponsorCode: string;
  public StateId: number;
  public ArrayUserId: string;
  public RoundId: number;
  public CreditAnalysis: any;
  public Address: string;
  public StateName: string;
  public PIN: string;
  public Abbreviation: string;
  public Zipcode: string;
  public dob: string;
  public ssn: string;
  public DateofBirth: Date;
  public SSN: string;
  ProgramColor: string;
}

export enum ContactTypeId{
  Lead = 1,
  Customer = 2,
  Graduated = 3,
  Cancelled = 4,
  Inactive = 5,
  Archive = 6
}


// WEBPACK FOOTER //
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/app/common/models/login/user-dc.ts